import { ManagerCalendarController } from './manager-calendar.controller';

export const ManagerCalendarComponent: ng.IComponentOptions = {
  bindings: {},
  templateUrl: 'calendar-events/views/manager-calendar/manager-calendar.html',
  controller: ManagerCalendarController,
};
